module.exports = __webpack_public_path__ + "img/superiority_icon3.149b3a8.png";